<template>
  <div class="w-full h-full">
    <div class="w-full custom-height overflow-y-auto overflow-x-hidden p-3">
      <el-form ref="form" label-width="150px" :rules="rules" :model="formData">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="承包商单位名称" prop="orgName">
              <el-input
                v-model="formData.orgName"
                placeholder="请输入承包商单位名称"
                maxlength="50"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="承包商单位简称" prop="orgShortName">
              <el-input
                v-model="formData.orgShortName"
                placeholder="请输入承包商单位简称"
                maxlength="50"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="pageType === 'create'">
            <el-form-item label="承包商单位负责人" prop="orgLeader">
              <el-input
                v-model="formData.orgLeader"
                placeholder="请输入承包商单位负责人"
                maxlength="50"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="pageType === 'update'">
            <el-form-item label="承包商单位负责人" prop="contractorPersonnelId">
              <el-select
                v-model="formData.contractorPersonnelId"
                placeholder="请选择承包商单位负责人"
                clearable
                filterable
                :disabled="currentStatus !== 2"
                @change="handleContractorSelect"
              >
                <el-option
                  v-for="item in filterUserList"
                  :key="item.id"
                  :label="item.contractorPersonnelName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="联系电话" prop="phoneNumber">
              <el-input
                v-model="formData.phoneNumber"
                placeholder="请输入联系电话"
                show-word-limit
                maxlength="50"
                :disabled="pageType !== 'create'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="审批资料模板" prop="profileTemplateId">
              <el-select
                v-model="formData.profileTemplateId"
                filterable
                placeholder="请选择审批资料模板"
                clearable
                :disabled="pageType !== 'create'"
              >
                <el-option
                  v-for="item in contractList"
                  :key="item.id"
                  :label="item.templateName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item class="remove-required" label="身份证号码" prop="idCard">
              <el-input
                v-model="formData.idCard"
                placeholder="请输入身份证号码"
                :disabled="pageType !== 'create'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="formData.email"
                placeholder="请输入邮箱"
                show-word-limit
                maxlength="50"
                :disabled="pageType !== 'create'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="所属专业" prop="ownerdSpecialtyId">
              <el-select
                v-model="formData.ownerdSpecialtyId"
                filterable
                placeholder="请选择所属专业"
                clearable
              >
                <el-option
                  v-for="item in specialtyList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="开始在厂时间" prop="startAtTheFactoryTime">
              <el-date-picker
                v-model="formData.startAtTheFactoryTime"
                type="date"
                placeholder="请选择开始在厂时间"
                :picker-options="startPickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="结束在厂时间" prop="endAtTheFactoryTime">
              <el-date-picker
                v-model="formData.endAtTheFactoryTime"
                type="date"
                placeholder="请选择结束在厂时间"
                :picker-options="endPickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import {
  ProfileTemplateConfigurationApi,
  ContractorPersonnelApi,
} from '@wiz-api/contractor-management'
import { SpecialtyApi } from '@wiz-api/team-management'
import utils from '@/components/safety/enumField/utils'

const contractorPersonnelApi = new ContractorPersonnelApi()
const profileTemplateConfigurationApi = new ProfileTemplateConfigurationApi()
const specialtyApi = new SpecialtyApi()

export default {
  name: 'contractor-form',
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    pageType: {
      type: String,
      default: 'create',
    },
    currentStatus: {
      type: Number,
      default: null,
    },
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('手机号不能为空'))
        return
      }
      const reg = /^1[3-9]{1}[0-9]{9}$/
      if (!reg.test(value)) {
        callback(new Error('请填写正确的手机号'))
        return
      }
      callback()
    }

    // 身份证验证
    const validateCard = (rule, value, callback) => {
      const reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (!value) {
        callback(new Error('请输入身份证'))
      } else if (reg.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确的身份证号码'))
      }
    }

    // 姓名校验
    const validateName = (rule, value, callback) => {
      // 中文
      const reg = /^[a-zA-Z]+$|^[\u4E00-\u9FA5]+$/
      if (!value) {
        callback(new Error('请输入姓名'))
      } else if (!reg.test(value)) {
        callback(new Error('姓名只能全中文或者全英文'))
      } else {
        callback()
      }
    }
    return {
      formLoading: false,
      formData: null,
      specialtyList: [],
      rules: {
        orgName: [{ required: true, message: '请输入承包商单位名称', trigger: ['blur', 'change'] }],
        orgShortName: [
          { required: true, message: '请输入承包商单位简称', trigger: ['blur', 'change'] },
        ],
        orgLeader: [{ required: true, validator: validateName, trigger: ['blur', 'change'] }],
        phoneNumber: [{ required: true, validator: validatePhone, trigger: ['blur', 'change'] }],
        profileTemplateId: [
          { required: true, message: '请选择审批资料模板', trigger: ['blur', 'change'] },
        ],
        ownerdSpecialtyId: [
          { required: true, message: '请选择所属专业', trigger: ['blur', 'change'] },
        ],
        email: [
          {
            required: false,
            message: '请输入邮箱',
            trigger: 'blur',
          },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change'],
          },
        ],
        idCard: [{ required: true, validator: validateCard, trigger: ['blur'] }],
        endAtTheFactoryTime: [
          { required: true, message: '请选择结束在厂时间', trigger: ['change'] },
        ],
        startAtTheFactoryTime: [
          { required: true, message: '请选择开始在厂时间', trigger: ['change'] },
        ],
      },
      contractList: [],
      userList: [],
      startPickerOptions: {
        disabledDate: (time) => {
          if (this.formData?.endAtTheFactoryTime) {
            const endAtTheFactoryTime = dayjs(this.formData.endAtTheFactoryTime)
            return time.valueOf() > endAtTheFactoryTime.valueOf()
          }
          return time.valueOf() < new Date().getTime() - 86400000
        },
      },
      endPickerOptions: {
        disabledDate: (time) => {
          if (this.formData?.startAtTheFactoryTime) {
            const startAtTheFactoryTime = dayjs(this.formData.startAtTheFactoryTime)
            return time.valueOf() < startAtTheFactoryTime.valueOf()
          }
          return time.valueOf() <= new Date().getTime() - 86400000
        },
      },
    }
  },
  created() {
    this.getSpecialtyList()
    // 获取配置指引
    this.getTemplateList()
    if (this.pageType === 'update') {
      // 获取承包商负责人
      this.getContractorPerson()
    }
  },
  computed: {
    filterUserList() {
      if (this.currentStatus !== 2) {
        return this.userList
      }
      return _.filter(this.userList, (item) => {
        return item.id === this.formData.orgLeader || item.status === 1
      })
    },
  },
  watch: {
    FormData: {
      handler(newVal, oldVal) {
        this.formData = newVal
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async getSpecialtyList() {
      const [err, res] = await specialtyApi.getSpecialtyDropDown()
      if (!err) {
        this.specialtyList = res
        this.specialtyList.unshift({ id: '00000000-0000-0000-0000-000000000000', name: '无专业' })
      }
    },
    // 负责人切换事件
    async handleContractorSelect(val) {
      if (val) {
        const [err, res] = await contractorPersonnelApi.get(val)
        if (!err) {
          // 赋值
          const { phoneNumber, idCard, email } = res
          this.formData.phoneNumber = phoneNumber
          this.formData.idCard = idCard
          this.formData.email = email
        }
      }
    },
    // 前往模板配置页面
    goTemplatePage() {
      this.$emit('template')
    },
    // 获取承包商负责人
    async getContractorPerson() {
      const [err, res] = await contractorPersonnelApi.contractorPersonnelNamesDto({
        contractorId: this.formData.id,
      })
      if (!err) {
        this.userList = res || []
      }
    },
    // 获取配置模板数据
    async getTemplateList() {
      const data = {
        maxResultCount: 999, // 每页多少条
        skipCount: 0, // 跳过多少条
      }
      const [err, res] = await profileTemplateConfigurationApi.pagedListQuery(data)
      if (!err) {
        this.contractList = res.items || []
      }
    },
    handleSave() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.formData.creationTime =
            this.formData.creationTime &&
            dayjs(this.formData.creationTime).format('YYYY-MM-DD HH:mm:ss')
          this.formData.lastModificationTime =
            this.formData.lastModificationTime &&
            dayjs(this.formData.lastModificationTime).format('YYYY-MM-DD HH:mm:ss')
          this.formData.entryTime =
            this.formData.entryTime && dayjs(this.formData.entryTime).format('YYYY-MM-DD HH:mm:ss')
          this.$emit('save', this.formData)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
